import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Alert } from "react-bootstrap";
import { postData, getData, putData } from "./API"; // Assuming getData function exists to fetch data
import { ToastContainer, toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";
 
function Surveyor() {
  const userId = localStorage.getItem("userId");
  const [filteredData, setFilteredData] = useState([]);
  const [show, setShow] = useState(false);
 
  const [messageError, setmessageError] = useState("");
  const [surveyorsList, setsurveyorsList] = useState([]);
  const [data, setData] = useState([]);
  const [editShow, setEditShow] = useState(false);
  const [selectedSurveyor, setSelectedSurveyor] = useState(null);
 
  const handleEditClose = () => {
    setEditShow(false);
    resetForm();
  };
 
  console.log("error", messageError);
 
  const [formData, setFormData] = useState({
    userName: "",
    displayName: "",
    mobile: "",
    email: "",
    password: "",
    firmTypeId: "",
    companyName: "",
  });
  const [formErrors, setFormErrors] = useState({
    userName: "",
    displayName: "",
    mobile: "",
    email: "",
    password: "",
    firmTypeId: "",
    companyName: "",
  });
  const [showUsernameAlert, setShowUsernameAlert] = useState(false);
  const [firm, setFirm] = useState("");
  const [filters, setFilters] = useState({
    name: "",
    fromDate: "",
    toDate: "",
  });
 
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };
 
  const handleFirmChange = (e) => {
    const selectedFirm = e.target.value;
    setFirm(selectedFirm);
    setFormData({ ...formData, firmTypeId: selectedFirm });
  };
 
  const handleClose = () => {
    setShow(false);
    resetForm();
  };
 
  const handleShow = () => setShow(true);
 
  const resetForm = () => {
    setFormData({
      userName: "",
      displayName: "",
      mobile: "",
      email: "",
      password: "",
      firmTypeId: "",
      companyName: "",
    });
    setFormErrors({
      userName: "",
      displayName: "",
      mobile: "",
      email: "",
      password: "",
      firmTypeId: "",
      companyName: "",
    });
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    // Validate form fields
    let valid = true;
    const newErrors = {
      userName: "",
      displayName: "",
      mobile: "",
      email: "",
      password: "",
      firmTypeId: "",
      companyName: "",
    };
 
    if (!formData.userName) {
      newErrors.userName = "User Name is Required";
      valid = false;
    } else if (!/^[a-zA-Z]+\.[a-zA-Z]+$/.test(formData.userName.trim())) {
      newErrors.userName =
        "Username should be in the firstname.lastname format";
      valid = false;
      setShowUsernameAlert(true);
    }
 
    if (!formData.displayName) {
      newErrors.displayName = "Name is Required";
      valid = false;
    }
 
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile Number is Required";
      valid = false;
    } else if (formData.mobile.trim().length < 10) {
      newErrors.mobile = "Mobile Number should be at least 10 digits";
      valid = false;
    } else if (formData.mobile.trim().length > 10) {
      newErrors.mobile = "Mobile Number should be exactly 10 digits";
      valid = false;
    }
 
    if (!formData.email.trim()) {
      newErrors.email = "Email is Required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      newErrors.email = "Invalid email address";
      valid = false;
    }
 
    if (!formData.password.trim()) {
      newErrors.password = "Password is Required";
      valid = false;
    }
 
    if (formData.firm === "Vendor" && !formData.companyName.trim()) {
      newErrors.companyName = "Company Name is Required for Vendor";
      valid = false;
    }
 
    if (!valid) {
      setFormErrors(newErrors);
      return;
    }
 
    // If form is valid, proceed with submission
    const newEntry = {
      UserName: formData.userName,
      MobileNumber: formData.mobile,
      EmailId: formData.email,
      displayName: formData.displayName,
      password: formData.password,
      firmTypeId: formData.firmTypeId,
      companyName: formData.companyName,
    };
 
    try {
      const res = await postData("Authentication/AddSurveyour", newEntry);
      // const response = await res.json();
      console.log("response", res);
      if (res && res.statusCode === 200) {
        toast.success("Surveyor added successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchDetails();
        setShow(false);
        resetForm();
      } else if (res && res.statusCode === 404) {
        console.log("error", res.message);
        setmessageError(res.message);
      }
    } catch (error) {
      console.log("Error adding surveyor:", error.message);
    }
  };
 
  const fetchDetails = async () => {
    try {
      const res = await getData("SurveyMasters/GetAllSurveyorsStats");
      // const response = await res.json();
      setData(res);
      setFilteredData(res);
    } catch (error) {
      console.log(error, "error from handling");
    }
  };
 
  useEffect(() => {
    fetchDetails();
    fetchSurveyor();
  }, []);
 
  const fetchSurveyor = async () => {
    let res = await getData("SurveyMasters/GetAllSurveyorsStats");
    // res = await res.json();
    setsurveyorsList(res);
  };
 
  const handleSearch = async () => {
    let UserId = filters.name;
    let FromDate = filters.fromDate;
    let ToDate = filters.toDate;
    let res = await getData(
      `SurveyMasters/GetAllSurveyorsFilters?FromDate=${FromDate}&ToDate=${ToDate}&UserId=${UserId}`
    );
 
    setFilteredData(res);
  };
 
  const downloadExcel = () => {
    const tableHeaders = [
      "S.No",
      "Name of the Surveyor",
      "No of Forms Completed",
    ];
    const tableData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Name of the Surveyor": item.userName,
      "No of Forms Completed": item.formsCompleted,
    }));
 
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: "A1" });
 
    // Set column widths
    worksheet['!cols'] = [
      { wpx: 50 },  // Width for S.No
      { wpx: 200 }, // Width for Name of the Surveyor
      { wpx: 150 }  // Width for No of Forms Completed
    ];
 
    // Align the header cells
    worksheet["A1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true }
    };
    worksheet["B1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true }
    };
    worksheet["C1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true }
    };
 
    // Align the data cells
    for (let i = 2; i <= tableData.length + 1; i++) {
      worksheet[`A${i}`].s = {
        alignment: { horizontal: "center", vertical: "center" }
      };
      worksheet[`B${i}`].s = {
        alignment: { horizontal: "left", vertical: "center" }
      };
      worksheet[`C${i}`].s = {
        alignment: { horizontal: "center", vertical: "center" }
      };
    }
 
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports Data");
    XLSX.writeFile(workbook, "SurveyorData.xlsx");
  };
 
  const statusCellRenderer = (params) => {
    const status = params.value; // Assuming the API returns true/false or "Active"/"Inactive"
    const statusText = status ? "Active" : "Inactive";
    const statusColor = status ? "green" : "orange";
 
    return (
      <>
        <span style={{ color: statusColor, fontWeight: "bold" }}>
          {statusText}
        </span>
      </>
    );
  };
 
  const columnDefs = [
    {
      headerName: "S.No",
      field: "sNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      headerClass: "grid-header",
    },
    {
      field: "userName",
      headerName: "Name of the surveyor",
      headerClass: "grid-header",
    },
 
    {
      field: "formsCompleted",
      headerName: "No of forms Completed",
 
      headerClass: "grid-header",
    },
 
    // {
    //   field: "isActive",
    //   headerName: "Status",
    //   cellRenderer: statusCellRenderer,
    //   headerClass: "grid-header",
    // },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   cellRenderer: (params) => {
    //     return (
    //       <button
    //         onClick={() => {
    //           setSelectedSurveyor(params.data);
    //           setEditShow(true);
    //         }}
    //         className="btn btn-sm rounded-3"
    //         style={{
    //           boxShadow:
    //             "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //           color: "white",
    //           background: "#9CA3AF",
    //           fontWeight: 600,
    //         }}
    //       >
    //         Edit
    //       </button>
    //     );
    //   },
    //   headerClass: "grid-header",
    //   cellClass: "no-right-border",
    //   suppressMenu: true,
    //   sortable: false,
    // },
  ];
 
  const defaultColDef = {
    sortable: true,
    resizable: true,
    flex: 1,
  };
 
  const handleStatusUpdate = async () => {
    try {
      const updatedSurveyor = {
        ...selectedSurveyor,
        isActive: selectedSurveyor.isActive,
      };
      const res = await putData(
        `Authentication/UpdateSurveyour`,
        updatedSurveyor
      );
      if (res && res.statusCode === 200) {
        toast.success("Status updated successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchDetails();
        setEditShow(false);
      } else {
        toast.error("Failed to update status", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error("Error updating status:", error.message);
    }
  };
 
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Surveyors</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="row filters ps-4 pt-3 pb-3 pe-4">
              <div className="col-md-6">
                <Form.Group controlId="userName" className="mb-3">
                  <Form.Label>User Name <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    type="text"
                    value={formData.userName}
                    onChange={(e) =>
                      setFormData({ ...formData, userName: e.target.value })
                    }
                    isInvalid={
                      !!formErrors.userName && !formData.userName.trim()
                    }
                    autoComplete="new-username"
                    placeholder="Enter your username"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.userName}
                  </Form.Control.Feedback>
                  {showUsernameAlert && (
                    <Alert
                      variant="danger"
                      onClose={() => setShowUsernameAlert(false)}
                      dismissible
                    >
                      Username should be in the firstname.lastname format
                    </Alert>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="displayName" className="mb-3">
                  <Form.Label>Name <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    type="text"
                    value={formData.displayName}
                    onChange={(e) =>
                      setFormData({ ...formData, displayName: e.target.value })
                    }
                    isInvalid={
                      !!formErrors.displayName && !formData.displayName.trim()
                    }
                    placeholder="Enter your name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.displayName}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="mobile" className="mb-3">
                  <Form.Label>Mobile Number <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    type="text"
                    value={formData.mobile}
                    onChange={(e) => {
                      // Extract only numbers from the input
                      const mobileValue = e.target.value
                        .replace(/\D/g, "") // Remove non-digit characters
                        .slice(0, 10); // Limit to 10 digits
                      setFormData({ ...formData, mobile: mobileValue });
                    }}
                    isInvalid={!!formErrors.mobile}
                    placeholder="Enter your Mobile Number"
                    autoComplete="off"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.mobile}
                  </Form.Control.Feedback>
                </Form.Group>
                {messageError === "Mobile Number is already registered" && (
                  <p className="text-danger">{messageError}</p>
                )}
              </div>
 
              <div className="col-md-6">
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    type="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    isInvalid={!!formErrors.email && !formData.email.trim()}
                    placeholder="Enter your Email"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                {messageError === "Email Id is already registered" && (
                  <p className="text-danger">{messageError}</p>
                )}
              </div>
              <div className="col-md-6">
                <Form.Group controlId="password" className="mb-3">
                  <Form.Label>Password <span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    type="password"
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    isInvalid={
                      !!formErrors.password && !formData.password.trim()
                    }
                    placeholder="Enter your Password"
                    autoComplete="new-password"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.password}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
 
              <div className="col-md-6">
                <Form.Group controlId="firm" className="mb-3">
                  <Form.Label>Firm</Form.Label>
                  <Form.Select
                    style={{
                      boxShadow:
                        "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                    }}
                    as="select"
                    value={formData.firmTypeId}
                    onChange={handleFirmChange}
                    isInvalid={
                      !!formErrors.firmTypeId && !formData.firmTypeId.trim()
                    }
                  >
                    <option value="">Select Firm</option>
                    <option value="1">ReS</option>
                    <option value="2">Vendor</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formErrors.firmTypeId}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              {formData.firmTypeId === "2" && (
                <div className="col-md-6">
                  <Form.Group controlId="companyName" className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      style={{
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                      type="text"
                      value={formData.companyName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          companyName: e.target.value,
                        })
                      }
                      isInvalid={
                        !!formErrors.companyName && !formData.companyName.trim()
                      }
                      placeholder="Enter your Company Name"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors.companyName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              type="submit"
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              SUBMIT
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
 
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <h1 className="title_pages">Surveyor Details</h1>
            </div>
            <div className="col-md-6 text-end">
              <Button
                variant="primary"
                onClick={handleShow}
                style={{
                  background: "#a7252ced",
                  border: "none",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                <i className="fa-solid fa-plus"></i> Add Surveyor
              </Button>
            </div>
          </div>
 
          <div className="row align-items-end">
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>Name of the Surveyor</label>
                <select
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                  name="name"
                  onChange={handleFilterChange}
                  className="form-select dropdown_input"
                >
                  <option value="">--Select--</option>
                  {surveyorsList.map((item) => (
                    <option value={item.userId} key={item.userId}>
                      {item.userName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
 
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>From Date</label>
                <input
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                  type="date"
                  className="form-control inputdate"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={handleFilterChange}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="form-group">
                <label>To Date</label>
                <input
                  style={{
                    background: "#D9D9D9",
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                  type="date"
                  className="form-control inputdate"
                  name="toDate"
                  value={filters.toDate}
                  onChange={handleFilterChange}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>
            <div className="col-md-3 mb-3 text-start">
              <button
                className="btn px-4 "
                onClick={handleSearch}
                style={{
                  background: "#a7252ced",
                  border: "none",
                  color: "white",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                SEARCH
              </button>
            </div>
          </div>
          <div className="text-start mb-3 mt-3">
            <button
              className="btn "
              onClick={downloadExcel}
              style={{
                background: "#9CA3AF",
                color: "white",
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              Excel <i className="fa-solid fa-download ms-1"></i>
            </button>
          </div>
 
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="table-responsive">
              <div className="ag-theme-alpine" style={{ height: 546.5, width: "100%", margin: "auto" }}>
                  <AgGridReact
                    defaultColDef={defaultColDef}
                    rowData={filteredData}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={10}
                    paginationPageSizeSelector={[ 10, 20, 50]}
                    rowHeight={45}
                  />
                </div>
              </div>
            </div>
          </div>
 
 
         
        </div>
 
 
 
        {/* <Modal show={editShow} onHide={handleEditClose}>
          <Modal.Body>
            <div className="text-center w-100 bg-light p-1">
              <h1>Edit Surveyor Status</h1>
            </div>
            <div className="d-flex justify-content-center align-items-center m-4 ">
              <Form.Check
                type="switch"
                id="custom-switch"
                label={selectedSurveyor?.isActive ? 'Deactivate' : 'Activate'}
                checked={selectedSurveyor?.isActive || false}
                onChange={(e) => {
                  setSelectedSurveyor({
                    ...selectedSurveyor,
                    isActive: e.target.checked,
                  });
                }}
                style={{height:"30px",
                  width: "60px"}}
             
              />
            </div>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                onClick={handleStatusUpdate}
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                Update Status
              </Button>
            </div>
          </Modal.Body>
        </Modal> */}
 
        <ToastContainer />
      </main>
    </>
  );
}
 
export default Surveyor;